import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService, RolePermissionService, ISearchProducts, IPaginationSearchRequestBaseModel, IProductResultResponseModel, IProductSupersedPartNumberModel, IProductCoreModel, ILookUpType, Environment, ENVIRONMENT } from 'lib-core-shared';

@Component({
  selector: 'app-supersede-product',
  templateUrl: './supersede-product.component.html',
  styleUrls: ['./supersede-product.component.scss']
})
export class SupersedeProductComponent implements OnInit, OnChanges {
  @Input() productMasterStatuses!: ILookUpType[];
  @Input() product: IProductCoreModel | undefined;
  @Input() productId!: string;

  @Input() basePartNumber!: string;
  @Input() public form!: FormGroup;
  @Output() public formEmitter = new EventEmitter<FormGroup>();
  public searchModel!: ISearchProducts;
  public products!: IProductSupersedPartNumberModel[];
  @Output() errorEmitter = new EventEmitter<any>();
  @Input() test!: string;
  public suggestedForm: FormGroup;
  public disabledForm: FormGroup;
  public allowMultipleSupercessions?: boolean = this.env.allowMultipleSupercessions;

  constructor(private fb: FormBuilder,
    public productService: ProductService,
    public roleService: RolePermissionService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    @Inject(ENVIRONMENT) private env: Environment,
    public modalService: NgbModal) {
      this.form = fb.group({
        supecededProducts: new FormArray([]),
      });

      this.disabledForm = fb.group({
        suggestionNumber: [null, Validators.required],
        suggestion: [null, Validators.required],
      });

      this.suggestedForm = fb.group({
        suggestionNumber: [null],
        suggestion: [null],
      });
      this.form.valueChanges.subscribe(X => this.formEmitter.emit(this.form));
      this.disabledForm.controls.suggestionNumber.disable();
  }
  ngOnChanges(changes: SimpleChanges): void {
    const latest = changes['product'];

    if (latest?.currentValue) {
      this.basePartNumber = latest.currentValue.basePartNumber;
      if ( this.basePartNumber) {
        this.searchModel = {
          exists: false,
          currentPage: 1,
          rowsPerPage: 10,
          partNumber: this.basePartNumber,
        } as unknown as ISearchProducts; 
        this.productService.search({
          searchModel: this.searchModel
        } as IPaginationSearchRequestBaseModel<ISearchProducts>).subscribe(products => 
          this.products= products.data.map((x:any) => this.mapProduct(x)), (e) => {
            this.errorEmitter.emit(e);
        });
      }
    }
  }

    ngOnInit(): void {
      const item = this.fb.group({
        exists: false,
        description: [null],
        productId: [null],
        partNumber: [null, Validators.required],
        quantity: [1, Validators.required]
      });
      ((this.form.controls.supecededProducts) as FormArray).push(item);
    }

    public removeSuperSede(index:number) {
      ((this.form.controls.supecededProducts) as FormArray).removeAt(index);
    }

    public superSedeExist(index: number, test: any = undefined) {
      const group =((this.form.controls.supecededProducts) as FormArray).controls[index] as FormGroup;
      group.controls['exists'].setValue(true);
      this.appendEmptySuperSede();
    }

    public appendEmptySuperSede() {
      const item = this.fb.group({
        exists: false,
        description: [],
        productId: [],
        partNumber: [null, Validators.required],
        quantity: [1, Validators.required]
      });
      this.appendSuperSede(item);
    }

    public appendSuggestedSuperSede() {
      const localiseSuggestion = this.suggestedForm.controls.suggestion.value;
      const item = this.fb.group({
        exists: false,
        description: [localiseSuggestion.description],
        productId: [localiseSuggestion.productId],
        partNumber: [localiseSuggestion.partNumber, Validators.required],
        quantity: [this.suggestedForm.controls.suggestionNumber.value, Validators.required]
      });
      this.appendSuperSede(item);
    }

    public appendSuperSede(item: FormGroup) {
      ((this.form.controls.supecededProducts) as FormArray).push(item);
    }
  
    public get supecededProducts(): FormArray {
      const result = this.form.get('supecededProducts') as FormArray;
      return result;
    }

    private mapProduct(entity: IProductResultResponseModel): IProductSupersedPartNumberModel {
      return {
        productId: entity.id,
        description: entity.shortDescription,
        partNumber: entity.partNumber
      } as IProductSupersedPartNumberModel
    }

    public get addDisableValidation(): boolean {
      return this.suggestedForm.controls.suggestionNumber.valid;
    }

    public formGroupCast(control: AbstractControl): FormGroup {
      return control as FormGroup;
    }
}